<template>
  <el-drawer v-model="visible" title="角色添加人员" size="50%" destroy-on-close>
    <el-row justify="space-between" style="margin-bottom:15px;align-items:center;">
      <span>组织：</span>
      <el-cascader v-model="id" :options="orgUnits" :props="orgProps" style="width:calc(100% - 60px);"
        @change="orgUnitChange" ref="orgUnitCascader" />
    </el-row>
    <el-table :data="users" tooltip-effect="dark" border stripe height="calc(100vh - 170px)" v-loading="loading">
      <el-table-column label="序号" width="55" type="index"></el-table-column>
      <el-table-column label="头像" width="80">
        <template #default="{row}">
          <el-avatar :size="50" v-if="row.photoPath" :src="row.photoPath"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed">
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template #default="{row}">
          <el-button type="text" @click="toTransfer(row.id)">转让</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-drawer>
</template>

<script>
import { getCurrEnterpriseUnitTree } from '@/api/enterprise';
import { getTransferUserList, transferSuperRole } from '@/api/enterprise/role';
import { defineComponent } from 'vue'

export default defineComponent({
  data() {
    return {
      visible: false,
      users: [],
      loading: false,
      tableColumns: [
        { prop: 'name', label: '姓名' },
        { prop: 'sex', label: '性别', width: 60 },
        { prop: 'phone', label: '手机号' },
      ],
      orgUnits: [],
      id: null,
      orgProps: {
        checkStrictly: true,
        emitPath: false,
        value: 'id',
        label: 'name'
      },
      userParams: {}
    }
  },
  methods: {
    show() {
      this.visible = true;
      this.getOrgUnits();
    },
    getOrgUnits() {
      getCurrEnterpriseUnitTree().then(({data}) => {
        this.orgUnits = data.data;
        this.orgUnitChange()
      })
    },
    getUsers() {
      this.loading = true;
      getTransferUserList(this.userParams).then(({data}) => {
        this.users = data.data;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    orgUnitChange() {
      let orgUnit;
      if (this.$refs.orgUnitCascader.getCheckedNodes().length) {
        orgUnit = this.$refs.orgUnitCascader.getCheckedNodes()[0].data
      } else {
        orgUnit = {}
      }
      this.userParams = {
        orgId: orgUnit.orgId,
        unitId: orgUnit.unitId
      }
      this.getUsers();
    },
    toTransfer(userId) {
      this.$confirm('确定将主管理员角色转让给此人？', '提示').then(_ => {
        transferSuperRole(userId).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.visible = false;
            this.$router.push('/login')
          } else {
            this.$message.warning(data.msg);
          }
        }).catch(_ => {})
      }).catch(_ => {})
    }
  }
})
</script>